import dayjs from "@shared/dayjs";
import { DocumentPropType } from "../../propTypes";

const TimeUploaded = ({ document = {} }) => (
  <td>
    <div className="tw-text-neutral-gray-75 tw-text-14d" data-cy="document-list-item-date-created-at">
      {dayjs(document.uploadedAt).format("MM/DD/YYYY")}
    </div>
    <div className="tw-text-neutral-gray-50 tw-text-12d" data-cy="document-list-item-time-created-at">
      {dayjs(document.uploadedAt).format("hh:mm A")}
    </div>
  </td>
);

TimeUploaded.propTypes = {
  document: DocumentPropType,
};

export default TimeUploaded;
